/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql } from '@apollo/client';

export const usePooledAccountOrderHistoryDetail = ({ transactionId }: any) => {
  const variables = {
    transactionId: transactionId 
  };
  const POOLEDORDERDETAIL_GQL = gql`
    query GetPooledOrderHistoryDetail($transactionId: Int!) {
    getPooledOrderHistoryDetail(transactionId: $transactionId) {
    ssOrderHistoryDetailError
    ShippingAddress {
      province
      city
      postalCode
      addressLine1
      addressLine2
      addressLine3
    }
    discountAmount{
      currency
      value
    }
    httpStatusCode
    status
    transactionType
    amount {
      currency
      value
    }
    billingAddress {
      province
      city
      postalCode
      addressLine1
      addressLine2
      addressLine3
    }
    inBranchOrderBranchAddress {
      province
      city
      postalCode
      addressLine1
      addressLine2
      addressLine3
    }
    inBranchOrderBranchName
    originTransactionReference
    inBranchOrderBranchNumber
    paymentAccountNumber
    paymentBankNumber
    paymentCreditCardNumber
    paymentBranchNumber
    paymentMethod
    promoCode
    settlementCurrency
    shippingFeeAmount{
      currency
      value
    }
    shippingFeeTaxAmount{
      currency
      value
    }
    transactionDate
    transactionId
    transactionItems {
      quantity
      productId
       item {
        fullImage
        name
      }
      productIdPrice {
        currency
        value
      }
      productAmountSubtotal {
        currency
        value
      }
    }
    transactionOrigin
  }
}
  `;

  const { data, loading, error } = useQuery(POOLEDORDERDETAIL_GQL, {
    variables,
     context:{
            clientName:"/secure-storage/order-details"
        }
  });

  return { data, loading, error };
};
